// ** Third Party Components
import { X } from "react-feather";
import Proptypes from "prop-types";
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";

import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const closeBtnStyles = {
  width: "32px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  border: "none",
  background: "rgba(0, 0, 0, 0.05)",
  cursor: "pointer",
  transition: "all 0.2s ease",
};

const Sidebar = (props) => {
  // ** Props
  const {
    open,
    size,
    title,
    width,
    footer,
    children,
    closeBtn,
    className,
    toggleSidebar,
    bodyClassName,
    contentClassName,
    wrapperClassName,
    headerClassName,
    ...rest
  } = props;

  // ** If user passes custom close btn render that else default close btn
  const renderCloseBtn = closeBtn ? (
    closeBtn
  ) : (
    <button
      type="button"
      style={closeBtnStyles}
      onClick={toggleSidebar}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(0, 0, 0, 0.05)";
      }}
    >
      <X size={18} color="#555" />
    </button>
  );

  return (
    <Modal
      isOpen={open}
      toggle={toggleSidebar}
      contentClassName={classnames("overflow-hidden", {
        [contentClassName]: contentClassName,
      })}
      modalClassName={classnames("modal-slide-in", {
        [wrapperClassName]: wrapperClassName,
      })}
      className={classnames({
        [className]: className,
        "sidebar-lg": size === "lg",
        "sidebar-sm": size === "sm",
      })}
      /*eslint-disable */
      {...(width !== undefined
        ? {
            style: { width: String(width) + "px" },
          }
        : {})}
      /*eslint-enable */
      {...rest}
    >
      <ModalHeader
        className={classnames({
          [headerClassName]: headerClassName,
        })}
        toggle={toggleSidebar}
        close={renderCloseBtn}
        tag="div"
      >
        <h5 className="modal-title">
          <span className="align-middle">{title}</span>
        </h5>
      </ModalHeader>
      <PerfectScrollbar options={{ wheelPropagation: false }}>
        <ModalBody
          className={classnames("flex-grow-1", {
            [bodyClassName]: bodyClassName,
          })}
        >
          {children}
        </ModalBody>
      </PerfectScrollbar>
      <ModalFooter
        // className={classnames({
        //   [headerClassName]: headerClassName,
        // })}
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f8f8f8",
          // marginBottom: "0",
        }}
        tag="div"
      >
        {footer}
      </ModalFooter>
    </Modal>
  );
};

export default Sidebar;

// ** PropTypes
Sidebar.propTypes = {
  className: Proptypes.string,
  bodyClassName: Proptypes.string,
  open: Proptypes.bool.isRequired,
  title: Proptypes.string.isRequired,
  contentClassName: Proptypes.string,
  wrapperClassName: Proptypes.string,
  children: Proptypes.any.isRequired,
  size: Proptypes.oneOf(["sm", "lg"]),
  toggleSidebar: Proptypes.func.isRequired,
  width: Proptypes.oneOfType([Proptypes.number, Proptypes.string]),
};
